import type { ToolkitBahanAjarDiscoveryExperiment } from 'types/toolkit'

import { createContext } from '@wartek-id/react-utils'

export interface ToolkitAbTestContextProps {
  experimentStatus: ToolkitBahanAjarDiscoveryExperiment
  deviceId: string
}

export const [ToolkitAbTestContextProvider, useToolkitAbTestContext] =
  createContext<ToolkitAbTestContextProps>({
    name: 'ToolkitAbTestContext',
    strict: false,
  })
